// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3ZTju","secondary":"styles_secondary__3BmXj","primary":"styles_primary__2SNJC"};